import { featurePages } from "./web-features.js";
import { hardware, industries, themesPage } from "./web-solutions.js";
/** পাবলিক মার্কেটিং সাইট (apps/web, docs/specs/marketing-site.md)। `{{brand}}` = কনফিগ করা প্রোডাক্টের নাম। */
export const web = {
    meta: {
        title: "{{brand}} — অনলাইন আর দোকানের বিক্রি, এক স্টকে",
        description: "ফেসবুকের অর্ডার, দোকানের কাউন্টার, কুরিয়ার আর সব ব্রাঞ্চ এক সিস্টেমে, এক স্টকে চালান। ইন্টারনেট চলে গেলেও POS বিক্রি চালিয়ে যায়। বাংলাদেশের জন্য বানানো।",
    },
    skipToContent: "মূল অংশে যান",
    nav: {
        label: "প্রধান মেনু",
        features: "ফিচার",
        themes: "থিম",
        pricing: "দাম",
        enterprise: "এন্টারপ্রাইজ",
        demo: "ডেমো",
        signIn: "সাইন ইন",
        startTrial: "ফ্রি ট্রায়াল শুরু করুন",
        tryIt: "নিজে চালিয়ে দেখুন",
        openMenu: "মেনু খুলুন",
        closeMenu: "মেনু বন্ধ করুন",
        home: "{{brand}} হোম",
    },
    language: {
        label: "ভাষা",
        switchTo: "English",
        switchToLabel: "View in English",
    },
    hero: {
        eyebrow: "বাংলাদেশের দোকান আর অনলাইন সেলারদের জন্য",
        title: "অনলাইন আর দোকান — এক সিস্টেমে, এক স্টকে।",
        body: "ফেসবুকের অর্ডার, দোকানের কাউন্টার আর সব ব্রাঞ্চ এক জায়গা থেকে। আর ইন্টারনেট না থাকলেও POS বিক্রি চালিয়ে যায়।",
        points: {
            offline: "নেট ছাড়াও চলে",
            couriers: "Steadfast · Pathao · RedX",
            bengali: "English আর বাংলা",
        },
    },
    home: {
        heroShotAlt: "{{brand}}-এর ড্যাশবোর্ড — দিন আর চ্যানেল অনুযায়ী এক সপ্তাহের বিক্রি",
        heroPhoneAlt: "{{brand}} দিয়ে বানানো একটা দোকানের নিজের ওয়েবসাইট, ফোনে",
        integrations: {
            title: "বাংলাদেশে যা চলে, তার সাথেই কাজ করে",
            payments: "পেমেন্ট",
            couriers: "কুরিয়ার",
        },
        problems: {
            eyebrow: "মার্চেন্টরা কেন বদলান",
            title: "চারটা ঝামেলা, একটাই সমাধান",
            body: "বেশিরভাগ দোকানে বিক্রি এক সফটওয়্যারে, স্টক খাতায়, আর কুরিয়ার তিনটা ওয়েবসাইটে। টাকা এখান দিয়েই হারায়।",
            before: "আগে",
            after: "{{brand}} দিয়ে",
            items: {
                stock: {
                    before: "শেষ পিসটা ফেসবুকে আর দোকানে — দুই জায়গাতেই বিক্রি হয়ে যায়।",
                    after: "সব চ্যানেলের জন্য এক স্টক। যেখানেই বিক্রি হোক, হিসাব সব জায়গায় ঠিক থাকে।",
                },
                offline: {
                    before: "নেট চলে গেলে কাউন্টারে বিল করা বন্ধ।",
                    after: "নেট ছাড়াই POS ৭ দিন পর্যন্ত বিল করে, নেট ফিরলে নিজেই সিঙ্ক হয়।",
                },
                couriers: {
                    before: "কুরিয়ারের প্যানেল, COD-এর হিসাব আর ফেক অর্ডার — সব আলাদা জায়গায়।",
                    after: "এক ক্লিকে Steadfast, Pathao বা RedX বুক করুন, COD মেলান, ফেক অর্ডার ধরুন।",
                },
                branches: {
                    before: "কোন ব্রাঞ্চে আজ কত বিক্রি, কী মাল আছে — কেউ জানে না।",
                    after: "সব ব্রাঞ্চ, গুদাম আর কাউন্টার এক ড্যাশবোর্ডে, লাইভ।",
                },
            },
        },
        branches: {
            eyebrow: "স্টক ও ব্রাঞ্চ",
            title: "সব ব্রাঞ্চ, এক স্টক",
            body: "কোন ব্রাঞ্চ আর গুদামে এই মুহূর্তে কী আছে দেখুন, এক জায়গা থেকে আরেক জায়গায় মাল পাঠান, দোকান বন্ধ না করেই স্টক গুনুন।",
            points: {
                live: "প্রতিটা ব্রাঞ্চ, গুদাম আর কাউন্টারের লাইভ স্টক",
                transfers: "পাঠানো আর বুঝে নেওয়ার ধাপসহ ট্রান্সফার",
                counts: "স্টক গণনা আর সমন্বয়, পুরো ইতিহাসসহ",
                purchasing: "পারচেজ অর্ডার, মাল গ্রহণ আর সাপ্লায়ারের পাওনা",
            },
            shotAlt: "{{brand}}-এ সব ব্রাঞ্চের প্রতিটা প্রোডাক্টের স্টক",
        },
        website: {
            eyebrow: "নিজের ওয়েবসাইট",
            title: "একই স্টক থেকে বিক্রি করা দোকানের ওয়েবসাইট",
            body: "বাংলাদেশের দোকানের জন্য বানানো ১২টা ডিজাইন থেকে একটা বেছে নিন, নিজের লোগো আর রং দিন, আর ক্যাশ অন ডেলিভারি, bKash বা Nagad-এ অর্ডার নিন।",
            browse: "সব থিম দেখুন",
            shotAlt: "{{name}} থিম",
            themes: {
                fashion_women: "মেয়েদের ফ্যাশন",
                fashion_men: "ছেলেদের পোশাক",
                cosmetics: "বিউটি",
                gadgets: "গ্যাজেট",
                grocery: "গ্রোসারি",
                home_kitchen: "ঘর ও রান্নাঘর",
                kids_baby: "শিশু ও বেবি",
                jewellery: "গয়না",
                home_food: "ঘরের খাবার",
                books: "বইয়ের দোকান",
                single_product: "এক প্রোডাক্ট",
                minimal: "মিনিমাল",
            },
        },
        accounts: {
            eyebrow: "হিসাব ও রিপোর্ট",
            title: "আজ কত লাভ হলো, জানুন",
            body: "সব চ্যানেলের বিক্রি, লাভ আর ক্যাশ নিজে থেকেই হিসাব হয়ে যায়। সন্ধ্যায় ক্যালকুলেটর নিয়ে বসতে হয় না।",
            points: {
                profit: "লাভ-ক্ষতি — দিন, ব্রাঞ্চ বা চ্যানেল ধরে",
                cod: "কুরিয়ারের তোলা COD, অর্ডারের সাথে মেলানো",
                vat: "VAT ইনভয়েস আর VAT রিপোর্ট",
                cash: "ক্যাশবুক, খরচ আর পাওনা",
                export: "সব রিপোর্ট Excel-এ নামানো যায়",
            },
            shotAlt: "{{brand}}-এর লাভ-ক্ষতির রিপোর্ট",
        },
        bengali: {
            eyebrow: "English আর বাংলা",
            title: "আপনার স্টাফ বাংলায় কাজ করতে পারবেন",
            body: "প্রত্যেকে নিজের ভাষা বেছে নেন। কাস্টমারের রিসিট, ইনভয়েস আর SMS-ও বাংলায় যেতে পারে, বাংলা সংখ্যাসহ।",
            english: "English",
            bangla: "বাংলা",
            shotAlt: "{{language}}-এ অর্ডারের স্ক্রিন",
        },
        start: {
            eyebrow: "শুরু করা",
            title: "১৫ মিনিটে বিক্রি শুরু",
            body: "কাউকে এসে সেটআপ করে দিতে হয় না, লম্বা ঝামেলা নেই। বেশিরভাগ দোকান সেদিনই প্রথম বিক্রি করে।",
            steps: {
                signup: { title: "সাইন আপ", body: "ফোন নম্বর আর ব্যবসার নাম। কোনো পেমেন্ট লাগে না।" },
                import: { title: "প্রোডাক্ট যোগ", body: "হাতে লিখুন, অথবা Excel ফাইল একবারে ইমপোর্ট করুন।" },
                pair: { title: "POS পেয়ার", body: "কাউন্টারের কম্পিউটারে ইনস্টল করে পেয়ারিং কোড দিন।" },
                sell: { title: "প্রথম বিক্রি", body: "স্ক্যান করুন, ক্যাশ বা bKash নিন, রিসিট প্রিন্ট করুন।" },
            },
        },
        pricing: {
            title: "সব সাইজের দোকানের জন্য সহজ মাসিক প্ল্যান",
            body: "ফ্রিতে শুরু করুন, তারপর দোকানের মাপে প্ল্যান বেছে নিন। ব্রাঞ্চ আর স্টাফ বাড়লে প্ল্যানও বাড়ে।",
            points: {
                trial: "ফ্রি ট্রায়াল, কোনো পেমেন্ট লাগে না",
                setup: "নিজে সাইন আপ করলে সেটআপ ফি নেই",
                change: "ব্যবসা বাড়লে প্ল্যান বদলান",
            },
            cta: "দাম দেখুন",
        },
        faq: {
            title: "মার্চেন্টরা যা জানতে চান",
            items: {
                offline: {
                    q: "ইন্টারনেট চলে গেলে কী হবে?",
                    a: "POS চলতেই থাকে: নেট ছাড়া ৭ দিন পর্যন্ত বিল, প্রিন্ট আর পেমেন্ট নেয়। নেট ফিরলে নিজে থেকেই সব বিল পাঠিয়ে দেয় — কোনোটা হারায় না, দুবারও গোনা হয় না।",
                },
                safety: {
                    q: "আমার ব্যবসার ডেটা কি নিরাপদ?",
                    a: "প্রতিটা ব্যবসার ডেটা অন্য সব ব্যবসা থেকে আলাদা রাখা হয়, পাসওয়ার্ড আর কুরিয়ারের কী এনক্রিপ্ট করা থাকে, আর প্রতি ঘণ্টায় ডেটাবেসের ব্যাকআপ হয়।",
                },
                moving: {
                    q: "এখনকার সফটওয়্যার থেকে প্রোডাক্ট আনা যাবে?",
                    a: "হ্যাঁ। Excel বা CSV-তে নামিয়ে ফাইলটা ইমপোর্ট করুন; কোনো সারি ঠিক করতে হলে তালিকায় দেখিয়ে দেওয়া হয়।",
                },
                hardware: {
                    q: "POS কোন কোন হার্ডওয়্যারে চলে?",
                    a: "Windows বা Mac কম্পিউটার, থার্মাল রিসিট প্রিন্টার, বারকোড স্ক্যানার, ক্যাশ ড্রয়ার আর বারকোড লেবেল প্রিন্টার।",
                },
                bengali: {
                    q: "স্টাফরা কি বাংলায় চালাতে পারবেন?",
                    a: "হ্যাঁ। প্রত্যেকে English বা বাংলা বেছে নেন, আর রিসিট, ইনভয়েস ও SMS বাংলায় প্রিন্ট আর পাঠানো যায়।",
                },
                website: {
                    q: "শুরু করতে কি ওয়েবসাইট লাগবে?",
                    a: "না। আগে ফেসবুক, WhatsApp বা ফোনে অর্ডার নিন; যখন ইচ্ছা নিজের ওয়েবসাইট চালু করুন।",
                },
            },
        },
        demos: {
            eyebrow: "এখানেই চালিয়ে দেখুন",
            note: "এই পেজে একটা সিমুলেশন। আসল সিস্টেম ঠিক এভাবেই কাজ করে।",
            reset: "আবার শুরু",
            stock: {
                title: "যেখানেই বিক্রি করুন, হিসাব ঠিক থাকে।",
                body: "শেষ শাড়িগুলো কাউন্টারে বিক্রি করুন বা ওয়েবসাইটে অর্ডার দিন — দুই জায়গাই একই স্টক দেখে, তাই শেষ পিসটা কখনো দুবার বিক্রি হয় না।",
                product: "জামদানি শাড়ি, লাল",
                counter: "দোকানের কাউন্টার (POS)",
                website: "আপনার ওয়েবসাইট",
                sellCounter: "কাউন্টারে ১টা বিক্রি",
                orderOnline: "ওয়েবসাইটে অর্ডার",
                inStock: "স্টকে {{count}}টা",
                soldOut: "স্টক শেষ",
                soldOutNote: "দুই চ্যানেলই ০-তে থেমেছে — কিছুই দুবার বিক্রি হয়নি।",
                log: "কী কী হলো",
                logCounter: "কাউন্টারে বিক্রি · স্টক {{from}} → {{to}}",
                logOnline: "ওয়েবসাইটে অর্ডার · স্টক {{from}} → {{to}}",
            },
            offline: {
                title: "নেট চলে গেছে। দোকান থামেনি।",
                body: "ইন্টারনেট বন্ধ করে বিল করতে থাকুন। নেট ফিরলে সব বিল নিজেই সিঙ্ক হয় — একটাও হারায় না, দুবারও যায় না।",
                internet: "ইন্টারনেট",
                on: "চালু",
                off: "বন্ধ",
                newBill: "নতুন বিল",
                bill: "বিল {{number}}",
                waiting: "সিঙ্কের অপেক্ষায়",
                syncing: "সিঙ্ক হচ্ছে…",
                synced: "সিঙ্ক হয়েছে",
                online: "অনলাইন — বিল সাথে সাথে অফিসে পৌঁছায়",
                offline: "অফলাইন — বিল এই কম্পিউটারেই নিরাপদে থাকে",
                queued: "{{count}}টা অপেক্ষায়",
                empty: "শুরু করতে একটা বিল করুন।",
            },
            courier: {
                title: "ফেসবুকের মেসেজ থেকে পৌঁছে যাওয়া পার্সেল",
                body: "একটা অর্ডার, শুরু থেকে শেষ: কাস্টমার যাচাই, কুরিয়ার বুকিং, আর ক্যাশ অন ডেলিভারির টাকা ফেরত আসা।",
                stepOf: "ধাপ {{n}} / ৪",
                steps: {
                    order: "নতুন অর্ডার",
                    check: "ফ্রড চেক",
                    book: "কুরিয়ার বুক",
                    cod: "COD ফেরত",
                },
                source: "ফেসবুক থেকে",
                customer: "নুসরাত জাহান",
                area: "মিরপুর ১০, ঢাকা",
                items: "২টা আইটেম",
                risk: "ঝুঁকি কম",
                history: "এই নম্বর: {{delivered}}টা ডেলিভারি, {{returned}}টা ফেরত · {{rate}} সফল",
                choose: "কুরিয়ার বেছে নিন",
                booked: "{{courier}}-এ বুক হয়েছে",
                tracking: "ট্র্যাকিং {{code}}",
                collected: "{{courier}} {{amount}} তুলেছে, এই অর্ডারের সাথে মিলে গেছে",
                next: "পরের ধাপ",
            },
        },
        final: {
            title: "পুরো দোকান চালান এক জায়গা থেকে",
            body: "আজই ফ্রি ট্রায়াল শুরু করুন, অথবা আগে একটা ডেমো দোকান চালিয়ে দেখুন — সাইন আপ লাগবে না।",
        },
    },
    demo: {
        metaTitle: "নিজে চালিয়ে দেখুন",
        eyebrow: "সাইন আপ নেই, কার্ড নেই",
        title: "আপনার নিজের ডেমো দোকান, কয়েক সেকেন্ডে তৈরি",
        body: "এক মাসের বিক্রি, দুটো ব্রাঞ্চ, একটা ওয়েবসাইট আর ব্রাউজারে চলা POS সহ একটা আসল দোকান পান। বিক্রি করুন, নেট বন্ধ করুন, অনলাইন অর্ডার নিন, কুরিয়ার বুক করুন — তারপর রিপোর্ট দেখুন।",
        points: {
            own: "২৪ ঘণ্টা শুধু আপনার, তারপর মুছে যায়",
            real: "দোকানগুলো প্রতিদিন যে সিস্টেমে চলে, সেটাই",
            nothing: "কাউকে কিছু যায় না: কোনো SMS, কুরিয়ার বা পেমেন্ট নয়",
        },
        start: "আমার ডেমো দোকান শুরু করুন",
        starting: "আপনার দোকান তৈরি হচ্ছে…",
        unavailable: "ডেমো এখনো চালু হয়নি। আমাদের মেসেজ করুন, আমরা সিস্টেম দেখিয়ে দেব।",
        errors: {
            busy: "এই মুহূর্তে সব ডেমো দোকান ব্যবহার হচ্ছে। এক মিনিট পর আবার চেষ্টা করুন।",
            tooMany: "আজ আপনি যথেষ্ট ডেমো দোকান চালিয়েছেন। চালিয়ে যেতে ফ্রি ট্রায়াল শুরু করুন।",
            bot: "আপনি রোবট নন তা যাচাই করা যায়নি। আবার চেষ্টা করুন।",
            failed: "কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।",
        },
        fallback: {
            title: "লাইভ ডেমো দোকানগুলো ঘুরে দেখুন",
            body: "প্রতিটি ডিজাইন একটা আসল দোকান হিসেবে চলছে — ঘুরে দেখুন, কার্টে যোগ করুন, চেকআউট করুন। ডেমো লাগবে না।",
        },
    },
    pricing: {
        metaTitle: "দাম",
        eyebrow: "দাম",
        title: "দোকানের সাথে বাড়ে, এমন সহজ প্ল্যান",
        body: "ফ্রি ট্রায়াল দিয়ে শুরু করুন — কোনো পেমেন্ট লাগে না। নিজে সাইন আপ করলে সেটআপ ফি নেই।",
        monthly: "মাসিক",
        yearly: "বাৎসরিক",
        perMonth: "/ মাস",
        perYear: "/ বছর",
        save: "বছরে {{amount}} সাশ্রয়",
        popular: "সবচেয়ে বেশি নেওয়া",
        start: "ফ্রি ট্রায়াল শুরু করুন",
        unlimited: "সীমাহীন",
        compareTitle: "সব ফিচার মিলিয়ে দেখুন",
        compareBody: "প্রতিটি প্ল্যানে কী আছে, পাশাপাশি।",
        seeAll: "সব ফিচার মিলিয়ে দেখুন",
        feature: "ফিচার",
        included: "আছে",
        notIncluded: "নেই",
        groups: {
            usage: "লিমিট",
            channels: "বিক্রির উপায়",
            stock: "স্টক ও অপারেশন",
            delivery: "ডেলিভারি",
            payments: "পেমেন্ট",
            customers: "কাস্টমার",
            accounts_reports: "হিসাব ও রিপোর্ট",
            team: "টিম",
            integrations: "ইন্টিগ্রেশন",
            support: "সাপোর্ট",
        },
        onRequest: "দাম শিগগিরই আসছে। মেসেজ করুন, আজই জানিয়ে দেব।",
        enterprise: {
            title: "বড় চেইন, নাকি পুরো সিস্টেম নিজের সার্ভারে?",
            body: "ডেডিকেটেড ইনস্ট্যান্স, ডেটা স্থানান্তর, ট্রেনিং আর আপনার মাপের চুক্তি।",
            cta: "আমাদের সাথে কথা বলুন",
        },
    },
    enterprise: {
        metaTitle: "এন্টারপ্রাইজ",
        eyebrow: "এন্টারপ্রাইজ",
        title: "পুরো সিস্টেম, শুধু আপনার ব্যবসার জন্য",
        body: "যেসব চেইন আর ব্র্যান্ডের নিজস্ব সার্ভার, নিজস্ব সীমা আর পাশে থেকে সব সেট করে দেওয়ার মতো একটা টিম দরকার, তাদের জন্য।",
        points: {
            dedicated: {
                title: "নিজের ইনস্ট্যান্স",
                body: "আপনার ডেটা আলাদা সার্ভারে — আমরা চালাই, অথবা লাইসেন্সে আপনার সার্ভারে।",
            },
            migration: {
                title: "ডেটা আমরাই নিয়ে আসি",
                body: "প্রোডাক্ট, স্টক, কাস্টমার আর হিসাব আপনার এখনকার সিস্টেম থেকে।",
            },
            training: {
                title: "ব্রাঞ্চে ট্রেনিং",
                body: "ম্যানেজার আর ক্যাশিয়ারদের বাংলায় ট্রেনিং, সরাসরি বা অনলাইনে।",
            },
            support: {
                title: "অগ্রাধিকার সাপোর্ট",
                body: "নির্দিষ্ট একজন যোগাযোগকারী, নির্দিষ্ট সময়ে উত্তর আর চালুর দিন পাশে থাকা।",
            },
        },
        formTitle: "আপনার ব্যবসার কথা বলুন",
        formBody: "এক কর্মদিবসের মধ্যে ফোন করব।",
    },
    leadForm: {
        name: "আপনার নাম",
        business: "ব্যবসার নাম",
        phone: "মোবাইল নম্বর",
        email: "ইমেইল (ঐচ্ছিক)",
        branches: "ব্রাঞ্চের সংখ্যা",
        message: "কী দরকার? (ঐচ্ছিক)",
        send: "পাঠান",
        sending: "পাঠানো হচ্ছে…",
        sent: "ধন্যবাদ! এক কর্মদিবসের মধ্যে আপনাকে ফোন করব।",
        errors: {
            phone: "বাংলাদেশি মোবাইল নম্বর দিন, যেমন 017XXXXXXXX।",
            required: "আপনার নাম, ব্যবসার নাম আর মোবাইল নম্বর দিন।",
            tooMany: "আপনার মেসেজ পেয়েছি। একটু অপেক্ষা করুন, অথবা ফোন করুন।",
            bot: "আপনি রোবট নন তা যাচাই করা যায়নি। আবার চেষ্টা করুন।",
            failed: "কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন বা WhatsApp-এ মেসেজ করুন।",
        },
    },
    contact: {
        whatsapp: "WhatsApp-এ কথা বলুন",
        call: "ফোন করুন",
    },
    footer: {
        tagline: "অনলাইন অর্ডার, দোকানের বিক্রি, ব্রাঞ্চ, কুরিয়ার আর হিসাব — সব এক সিস্টেমে।",
        product: "প্রোডাক্ট",
        solutions: "আপনার ব্যবসার জন্য",
        company: "কোম্পানি",
        legal: "নীতিমালা",
        links: {
            pos: "নেট ছাড়াও চলা POS",
            onlineOrders: "অনলাইন অর্ডার ও কুরিয়ার",
            inventory: "স্টক ও ব্রাঞ্চ",
            storefront: "নিজের ওয়েবসাইট",
            accounts: "হিসাব ও রিপোর্ট",
            ebooks: "ই-বুক ও ডিজিটাল",
            hardware: "হার্ডওয়্যার",
            fashion: "ফ্যাশন",
            grocery: "মুদি ও গ্রোসারি",
            cosmetics: "কসমেটিকস",
            gadgets: "গ্যাজেট",
            bookshop: "বইয়ের দোকান",
            about: "আমাদের কথা",
            contact: "যোগাযোগ",
            terms: "শর্তাবলি",
            privacy: "গোপনীয়তা",
            refund: "রিফান্ড নীতি",
        },
        madeIn: "বাংলাদেশে তৈরি",
        rights: "© {{year}} {{brand}}। সর্বস্বত্ব সংরক্ষিত।",
    },
    notFound: {
        title: "পেজটা এখানে নেই",
        body: "লিংকটা হয়তো পুরোনো, অথবা পেজটা এখনো তৈরি হচ্ছে।",
        home: "হোম পেজে ফিরে যান",
    },
    featurePages,
    industries,
    themesPage,
    hardware,
};
//# sourceMappingURL=web.js.map